import { render, staticRenderFns } from "./c-requests-table.vue?vue&type=template&id=08f056c2&scoped=true&"
import script from "./c-requests-table.vue?vue&type=script&lang=js&"
export * from "./c-requests-table.vue?vue&type=script&lang=js&"
import style0 from "./c-requests-table.vue?vue&type=style&index=0&id=08f056c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f056c2",
  null
  
)

export default component.exports